/**
 * 显示各类弹出通知消息的vue 插件
 */
import eventBus from '@/utils/event-bus'
import CheckModal from './CheckModal'
import LightTip from './LightTip'
import ImageModal from './ImageModal'
import { Message } from 'element-ui'

const plugin = {}

function isMobile() {
    return screen.availWidth < 600
}

plugin.install = function(Vue) {
    const createElement = new Vue().$createElement
    eventBus.$on('showMessage', args => {
        if (!args || typeof args === 'string') {
            args = {
                message: args
            }
        }
        if (typeof args.message === 'function') {
            args.message = args.message(createElement)
        }

        if (isMobile()) {
            if (!args.customClass) {
                args.customClass = ''
            }
            args.customClass += ' mobile-message'
            args.showClose = false
        }
        // 调用element ui的message
        Message(args)
    })

    eventBus.$on('checkModal', args => {
        if (!args || typeof args === 'string') {
            args = {
                message: args
            }
        }
        if (typeof args.message === 'string') {
            const message = args.message
            // eslint-disable-next-line
        args.message = h => <div>{message}</div>
        }

        if (!args.buttons) {
            args.buttons = [
                {
                    text: '取消',
                    style: { color: '#666666' }
                }
            ]
        }
        for (let btn of args.buttons) {
            if (!btn.style) {
                btn.style = {}
            }
            if (!btn.callback) {
                btn.callback = () => true
            }
            const callback = btn.callback || (() => true)
            btn.callback = () => {
                if (callback()) {
                    remove()
                }
            }
        }

        let mounted
        function remove() {
            document.body.removeChild(mounted.$el)
        }
        const el = document.createElement('div')
        document.body.appendChild(el)
        const inst = Vue.extend(CheckModal)
        mounted = new inst({
            el,
            propsData: args,
            methods: {
                remove
            }
        })
    })

    eventBus.$on('showTip', args => {
        if (!args || typeof args === 'string') {
            args = {
                message: args
            }
        }
        if (typeof args.message === 'string') {
            const message = args.message
            // eslint-disable-next-line
            args.message = h => <div>{message}</div>
        }

        const el = document.createElement('div')
        document.body.appendChild(el)
        const inst = Vue.extend(LightTip)
        const mounted = new inst({
            el,
            propsData: args,
            methods: {
                remove() {
                    document.body.removeChild(mounted.$el)
                }
            }
        })
    })

    eventBus.$on('showImage', function(args) {
        if (typeof args === 'string') {
            args = {
                imageUrl: args
            }
        }

        const el = document.createElement('div')
        document.body.appendChild(el)
        const inst = Vue.extend(ImageModal)
        const mounted = new inst({
            el,
            propsData: args,
            methods: {
                remove() {
                    document.body.removeChild(mounted.$el)
                }
            }
        })
    })

    // 原型对象的方法
    Vue.prototype.$info = {
        // 自顶向下显示文字提示
        showMessage(msg) {
            eventBus.$emit('showMessage', msg)
        },
        // 弹出确认框
        checkModal(msg) {
            eventBus.$emit('checkModal', msg)
        },
        // 显示黑底白字的提示信息
        showTip(msg) {
            eventBus.$emit('showTip', msg)
        },
        // 弹出图片显示
        showImage(msg) {
            eventBus.$emit('showImage', msg)
        }
    }
}

export default plugin



// WEBPACK FOOTER //
// ./src/components/info/info-plugin.js